import React, { useState, useEffect } from "react";
import "../i18n/config";
import i18next from "i18next";
import { Row, Col, Table } from "react-bootstrap";
import apiService from "../services/api.service";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as moment from 'moment';
import CustomerReqTableComponent from "./CustomerReqTable";
import { useTranslation } from "../hooks/useTranslation";

function ContactFormComponent(props) {

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    trigger,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
  });

  const [lang, setLang] = useState("");
  const { t } = useTranslation();
  const location = useLocation();
  const chainId = new URLSearchParams(location.search).get("chainid") || 0;
  const [allCustomerRequests, setallCustomerRequests] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const TextAreaMaxLength = t("GiftTextAreaMaxLength");
  const [isSendingProc, setIsSendingProc] = useState(false);

  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };

  useEffect(() => {
    setLang(new URLSearchParams(location.search).get("lang") || "eng");


  }, []);

  useEffect(() => {
    SetLanguage(lang);
  }, [lang]);





  const clearText = (id) => {
    document.getElementById(id).value = "";
    var countfield = document.getElementById("counter");
    countfield.innerHTML = "0/" + TextAreaMaxLength;
  };

  const textCounter = (field, field2, maxlimit) => {
    var countfield = document.getElementById(field2);
    var textarea = document.getElementById(field);
    if (textarea.value.length > maxlimit) {
      textarea.value = textarea.value.substring(0, maxlimit);
      return false;
    }
    else {
      countfield.innerHTML = textarea.value.length + "/" + maxlimit;
    }
  }

  const submitContactForm = (data) => {

    let valid = true;
    let errorMsg = "";
    setIsSendingProc(true);


    if (!valid || data.MessageContactInput === "") {
      errorMsg = t("CheckAllFields");
      alert(errorMsg);
      setErrorMessage(errorMsg);
      setTimeout(() => {
        setErrorMessage("");
        setIsSendingProc(false);
      }, 4000);

    }
    else {
      if (data.MessageContactInput) {

        if (window.location.href.includes("cxl=1")) {
          saveCustomerRequest(data.fullNameContactInput, data.EmailContactInput, data.PhoneContactInput, t("RsvNum") + data.RsvNumInput + ", " + data.MessageContactInput, data.PassportInput);
        }
        else {
          saveCustomerRequest(data.fullNameContactInput, data.EmailContactInput, data.PhoneContactInput, data.MessageContactInput);
        }


      }

    }

  };

  const saveCustomerRequest = (fullname, email, phone, message, customerPassport = null) => {
    apiService
      .insertContactFormReq(fullname, phone, email, message, chainId, null, customerPassport)
      .then((res) => {
        if (res) {

          setErrorMessage(t("CustomerReqSendSuccess"));
          setIsSendingProc(false);
          reset();  
        }
        else {
          setErrorMessage(t("CustomerReqSendSuccess"));
          setIsSendingProc(false);
        }

        setTimeout(() => {
          setErrorMessage("");

        }, 4000);

      })
      .catch((err) => {
        console.error(err);
        setIsSendingProc(false);
      });

  };

  const passportValidation = (value) => {
    let id = String(value).trim();
    if (id.length > 9 || id.length < 5 || isNaN(id)) {
      return t("InvalidPassport");
    }

    // Pad string with zeros up to 9 digits
    id = id.length < 9 ? ("00000000" + id).slice(-9) : id;
    const isIdStructureValid = (Array
      .from(id, Number)
      .reduce((counter, digit, i) => {
        const step = digit * ((i % 2) + 1);
        return counter + (step > 9 ? step - 9 : step);
      }) % 10 === 0);
    if (!isIdStructureValid) {
      return t("InvalidPassport");
    }

    return true;
  }

  return (
    <>
      <div className="my-account-wrap">
        <Row>
          <Col>
            <div id="contactformTab" className="account-section">
              <h4 id="contact-title" aria-label={window.location.href.includes("cxl=1") ? t("CancelRsv") : t("ContactForm")}>{window.location.href.includes("cxl=1") ? t("CancelRsv") : t("ContactForm")}</h4>
              <div role="heading" aria-label={window.location.href.includes("cxl=1") ? t("CancelRsvSubText") : t("ContactFormSubText")}>{window.location.href.includes("cxl=1") ? t("CancelRsvSubText") : t("ContactFormSubText")}</div>
              <form onSubmit={handleSubmit((data) => submitContactForm(data))} aria-labelledby="contact-title">
                <div className="personal-details-form-wrap box">
                  <div >
                    <Row>
                      <Col xs="12" md="6">
                        <label htmlFor="fullNameContactInput"> {t("FullName")}</label>
                        <input
                        id="fullNameContactInput"
                          name="fullNameContactInput"
                          {...register("fullNameContactInput", {
                            required: t("Required"),
                            pattern: {
                              value: new RegExp(t("FullNameRegex")),
                              message: t("FullNameRegexMsg"),
                            },
                          })}

                        />
                        <span role="alert" className="error">{errors.fullNameContactInput?.message}</span>
                      </Col>
                      <Col xs="12" md="6">
                        <label htmlFor="PhoneContactInput"> {t("Phone")}</label>
                        <input
                        id="PhoneContactInput"
                          name="PhoneContactInput"
                          {...register("PhoneContactInput", {
                            required: t("Required"),
                            pattern: {
                              value: new RegExp(t("PhoneRegex")),
                              message: t("PhoneRegexMsg"),
                            },
                          })}

                        />
                        <span role="alert" className="error">{errors.PhoneContactInput?.message}</span>
                      </Col>
                    </Row>

                    {window.location.href.includes("cxl=1") &&
                      <Row>
                        <Col xs="12" md="6">
                          <label htmlFor="PassportInput"> {t("Passport")}</label>
                          <input
                          id="PassportInput"
                            type="tel"
                            name="PassportInput"
                            {...register("PassportInput", {
                              required: t("Required"),
                              validate: { validateID: passportValidation }
                            })}

                          />
                          <span role="alert" className="error">{errors.PassportInput?.message}</span>
                        </Col>
                        <Col xs="12" md="6">
                          <label htmlFor="RsvNumInput"> {t("RsvNum").replace(":", "")}</label>
                          <input
                          id="RsvNumInput"
                            type="tel"
                            name="RsvNumInput"
                            {...register("RsvNumInput", {
                              required: t("Required"),

                            })}

                          />
                          <span role="alert" className="error">{errors.RsvNumInput?.message}</span>
                        </Col>
                      </Row>}

                    <Row>
                      <Col xs="12" md="6">
                        <label htmlFor="EmailContactInput"> {t("Email")}</label>
                        <input
                        id="EmailContactInput"
                          name="EmailContactInput"
                          {...register("EmailContactInput", {
                            required: t("Required"),
                            pattern: {
                              value: new RegExp(t("EmailRegex")),
                              message: t("EmailRegexMsg"),
                            },
                          })}

                        />
                        <span role="alert" className="error">{errors.EmailContactInput?.message}</span>
                      </Col>
                      <Col xs="12" md="6">
                        <Row>
                          <Col sm={12} md={6}><label htmlFor="MessageContactInput"> {t("ContactMessage")}</label>    </Col>
                          <Col sm={12} md={6} className="botom-inputs">
                            <div className="words-counter">
                              <span className="delete" onClick={e => clearText('MessageContactInput')}>{t("Delete")}</span>
                              <span id={"counter"}>0/{TextAreaMaxLength}</span>

                            </div>
                          </Col>
                        </Row>
                        <textarea className="text-area"
                          id={'MessageContactInput'}
                          onKeyUp={e => textCounter('MessageContactInput', 'counter', TextAreaMaxLength)}
                          name="MessageContactInput"
                          {...register("MessageContactInput", { maxLength: TextAreaMaxLength }, {
                            required: t("Required"),

                          })} rows="4" ></textarea>
                        <span className="error">{errors.MessageContactInput?.message}</span>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12" md="6">

                      </Col>
                      <Col xs="12" md="6">
                        <input
                        aria-label={isSendingProc ? t("Sending") : t("Send")}
                          type="submit"
                          className="btn"
                          value={isSendingProc ? t("Sending") : t("Send")}
                          disabled={isSendingProc}
                        />
                      </Col>
                    </Row>


                  </div>
                </div>
              </form>
              <div className={!errorMessage ? "hidden" : "error-msg box"}>
                {errorMessage}
              </div>
              {!window.location.href.includes("contact") && <CustomerReqTableComponent message={t("YourRequests")} allCustomerRequests={allCustomerRequests} ></CustomerReqTableComponent>}



            </div>
          </Col>
        </Row>

      </div>
    </>
  );

}

export default ContactFormComponent;
